"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractNum = extractNum;
exports.getEndPoint = getEndPoint;
exports.translateXForElement = translateXForElement;
exports.vwToPx = vwToPx;
exports.w = w;
/**
 * Function to read transform property on element.
 *
 * @param {HTMLElement} element The element to read attributes from
 * @returns {Number} Return New Position of Element
 */
function translateXForElement(element) {
  const transform = element.style.transform;
  const extractTranslateX = transform.match(/translate(?:X|3d)\((-?\d+)/);
  if (!extractTranslateX || extractTranslateX.length !== 2) {
    return 0;
  }
  return parseInt(extractTranslateX[1], 10);
}
function vwToPx(viewportWidth, vw) {
  return vw * viewportWidth / 100;
}

/**
 * Function to read transform property on element.
 *
 * @param {string} str String to extract number from
 * @returns {Number} Return a number
 */
function extractNum(str) {
  return Number(str.replace(/\D/g, ''));
}
function w() {
  if (typeof window === 'undefined') {
    return {};
  }
  return window;
}
function getEndPoint({
  side,
  direction,
  containerWidth,
  slidesWidth
}) {
  const endPoint = containerWidth - slidesWidth - vwToPx(containerWidth, 8);
  if (direction === 'rtl') {
    return side === 'right' ? -endPoint : 0;
  }
  return side === 'left' ? endPoint : 0;
}